// extracted by mini-css-extract-plugin
export var chip = "_qw-2";
export var chipBody = "_qw-8";
export var chipHeader = "_qw-9";
export var chipWithKind = "_qw-7";
export var icon = "_qw-3";
export var kind = "_qw-a";
export var remove = "_qw-5";
export var removeIcon = "_qw-6";
export var row = "_qw-0";
export var rowHistorical = "_qw-1";
export var text = "_qw-4";